var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "", "pa-0": "" } },
    [
      _c(
        "v-row",
        {
          attrs: {
            align: "center",
            justify: "center",
            height: _vm.pageHeight < 480 ? "110vh" : "100vh",
            dense: "",
          },
        },
        [
          _c(
            "v-col",
            {
              staticClass:
                "fill-height d-flex flex-column justify-center align-center",
              attrs: { cols: "12", lg: "6", md: "6" },
            },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "", "max-width": "800px" } },
                            [
                              _vm.authenticationError
                                ? _c(
                                    "v-alert",
                                    {
                                      attrs: { type: "error", dismissible: "" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "login.messages.error.authentication"
                                              )
                                            ),
                                          },
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v("Failed to sign in!"),
                                          ]),
                                          _vm._v(
                                            " Please check your credentials and try again."
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center", justify: "center" } },
                        [
                          _c("img", {
                            attrs: {
                              width: "145",
                              height: "50",
                              src: "/content/images/TheStudio_Logo_Lockup-Stacked_Dark.svg",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    {
                      attrs: {
                        flat: "",
                        "max-width": "390px",
                        "min-width": "350px",
                      },
                    },
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "toastify-container",
                              attrs: { cols: "10" },
                            },
                            [
                              _c(
                                "form",
                                {
                                  attrs: { role: "form" },
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.doLogin()
                                    },
                                  },
                                },
                                [
                                  _c("v-row", [
                                    _c("span", { staticClass: "input-label" }, [
                                      _vm._v("Email/Username"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-text-field", {
                                        ref: "username",
                                        staticClass: "text-transparent",
                                        attrs: {
                                          id: "username",
                                          name: "username",
                                          "hide-details": "false",
                                          clearable: "",
                                          outlined: "",
                                          color: "#2563EB",
                                          dense: "",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.$v.login.$touch()
                                          },
                                          blur: function ($event) {
                                            return _vm.$v.login.$touch()
                                          },
                                          focus: function ($event) {
                                            return _vm.focusInput()
                                          },
                                        },
                                        model: {
                                          value: _vm.login,
                                          callback: function ($$v) {
                                            _vm.login = $$v
                                          },
                                          expression: "login",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.$v.login.$anyDirty &&
                                  _vm.$v.login.$invalid
                                    ? _c("v-row", [
                                        _c("div", [
                                          _c(
                                            "small",
                                            {
                                              staticClass:
                                                "form-text text-danger",
                                            },
                                            [
                                              _vm._v(
                                                "\n                            Required.\n                        "
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("v-row", { staticClass: "mt-8" }, [
                                    _c("span", { staticClass: "input-label" }, [
                                      _vm._v("Password"),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-text-field", {
                                        ref: "password",
                                        staticClass: "text-transparent",
                                        attrs: {
                                          id: "password",
                                          name: "password",
                                          "append-icon": _vm.hidden
                                            ? "visibility"
                                            : "visibility_off",
                                          type: _vm.hidden
                                            ? "password"
                                            : "text",
                                          "hide-details": "false",
                                          color: "#2563EB",
                                          outlined: "",
                                          dense: "",
                                        },
                                        on: {
                                          "click:append": () =>
                                            (_vm.hidden = !_vm.hidden),
                                          input: function ($event) {
                                            return _vm.$v.password.$touch()
                                          },
                                          blur: function ($event) {
                                            return _vm.$v.password.$touch()
                                          },
                                          focus: function ($event) {
                                            return _vm.focusInput()
                                          },
                                        },
                                        model: {
                                          value: _vm.password,
                                          callback: function ($$v) {
                                            _vm.password = $$v
                                          },
                                          expression: "password",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-row", [
                                    _vm.$v.password.$anyDirty &&
                                    _vm.$v.password.$invalid
                                      ? _c("div", [
                                          _c(
                                            "small",
                                            {
                                              staticClass:
                                                "form-text text-danger mt-n2",
                                            },
                                            [
                                              _vm._v(
                                                "\n                            Required.\n                        "
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "forgot-label hover-underline-animation right",
                                        on: { click: _vm.forgot },
                                      },
                                      [_vm._v("Forgot Password")]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-row", [
                                    _vm._v(
                                      "\n                   \n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "entity-button-text white--text",
                                          attrs: {
                                            color: "#FF4800",
                                            type: "submit",
                                            block: "",
                                            loading: _vm.loading,
                                            disabled:
                                              _vm.loading || _vm.hasEmptyValues,
                                          },
                                        },
                                        [_vm._v("Sign in\n                  ")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { align: "center" } },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "or-label" },
                                            [_vm._v("OR")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "entity-button-text register-btn",
                                          attrs: {
                                            color: "#FF4800",
                                            block: "",
                                            outlined: "",
                                          },
                                          on: { click: _vm.register },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Register for New Account\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-row",
                                    { staticClass: "mt-4" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "entity-button-text sso-btn",
                                          attrs: {
                                            color: "transparent",
                                            block: "",
                                            text: "",
                                          },
                                          on: { click: _vm.openSSO },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    SSO Login\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-row", { staticClass: "mb-10" }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                {
                  class:
                    _vm.pageHeight > 480 ? "card-footer" : "card-footer-sm",
                  attrs: { flat: "" },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { align: "center", justify: "center" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  class:
                                    _vm.pageHeight > 480
                                      ? "footer-policy"
                                      : "footer-policy-sm",
                                  style:
                                    _vm.isMobile && _vm.pageHeight > 480
                                      ? "width: 72%; left:13%"
                                      : _vm.pageHeight > 480
                                      ? "left:9%; width: 31%"
                                      : "width: 50%",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "footer-policy-txt" },
                                    [
                                      _vm._v(
                                        "Unless otherwise agreed upon in writing, use of this software is subject to the ELB Learning Subscription and "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          staticStyle: { color: "#1D4ED8" },
                                          attrs: {
                                            href: "https://www.elblearning.com/subscription-and-license-agreement",
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v("License Agreement")]
                                      ),
                                      _vm._v(" and "),
                                      _c(
                                        "a",
                                        {
                                          staticStyle: { color: "#1D4ED8" },
                                          attrs: {
                                            href: "https://www.elblearning.com/privacy-policy",
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v("Privacy Policy")]
                                      ),
                                      _vm._v("."),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  class:
                                    _vm.pageHeight > 480
                                      ? "footer-copy"
                                      : "footer-copy-sm",
                                  style:
                                    _vm.isMobile && _vm.pageHeight > 480
                                      ? "width: 72%; left:13%"
                                      : _vm.pageHeight > 480
                                      ? "left:9%; width: 31%"
                                      : "width: 50%",
                                  attrs: { align: "center" },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      "© " +
                                        _vm._s(_vm.year) +
                                        " ELB Learning. All rights reserved."
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-overlay",
                { attrs: { absolute: true, value: _vm.loading } },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: "60" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass:
                "justify-center align-center shrink hidden-sm-and-down",
              staticStyle: { padding: "0px" },
              attrs: { cols: "12", lg: "6", md: "6" },
            },
            [
              _c("v-img", {
                attrs: {
                  height: _vm.pageHeight < 480 ? "140vh" : "100vh",
                  src: "/content/images/LoginScreen_BG-image.webp",
                },
              }),
              _vm._v(" "),
              _vm.pageHeight > 480
                ? _c("img", {
                    staticClass: "img-logo",
                    attrs: {
                      src: "/content/images/ELB-Learning_Logo_White.svg",
                    },
                  })
                : _c("img", {
                    staticClass: "img-logo-sm",
                    attrs: {
                      src: "/content/images/ELB-Learning_Logo_White.svg",
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }